<template>
	<el-row class="points-show">
		<el-col :span="23">
			养熟体系
		</el-col>
		<el-divider></el-divider>
		<div>
			<el-col :span="24">
				<el-button size="mini" @click="append(-1)">
					新增一级目录
				</el-button>
			</el-col>
			<el-col :span="24">
				<div class="block">
					<el-tree :data="data" node-key="dicId" :expand-on-click-node="false" :render-content="renderContent"
						:props="treePorps">
					</el-tree>
				</div>
			</el-col>
		</div>
		<el-dialog :title="text" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="名称" :label-width="formLabelWidth">
					<el-input v-model="form.name" autocomplete="off"></el-input>
				</el-form-item>
				<el-form-item label="类型" :label-width="formLabelWidth" v-if="isadd">
					<el-select v-model="form.leixing" placeholder="请选择">
						<el-option label="目录" :value="0"></el-option>
						<el-option label="表单" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="文案" :label-width="formLabelWidth" v-if="form.leixing==1">
					<el-select v-model="form.tiaozhuan" placeholder="请选择">
						<el-option v-for="item in tiaozhuanlist" :label="item.dicDesc" :key="item.dicId"
							:value="item.dicId"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="addtree">确 定</el-button>
			</div>
		</el-dialog>
	</el-row>
</template>
<script>
	import httpClient from '../../../util/request.js';
	export default {
		data() {
			return {
				data: [],
				text: "修改",
				dialogFormVisible: false,
				form: {
					name: '',
					leixing: null,
					tiaozhuan: '',
				},
				formLabelWidth: '60px',
				tiaozhuanlist: [],
				pid: -1,
				isadd: true,
				treePorps: {
					label: 'dicDesc',
					children: 'childList'
				}
			}
		},
		created() {
			// 进入页面请求1级目录
			this.gettree();
			var url = '/api/source/matDic/selectByParentId?pid=182';
			this.$http.get(url).then(res => {
				if (res.data.status == 0) {
					console.log("请求类型成功！", res.data.data)
					this.tiaozhuanlist = res.data.data;
				} else {
					console.log("请求类型失败！")
				}
			});
			var url = '/api/source/matDic/selectByParentId?pid=186';
			this.$http.get(url).then(res => {
				if (res.data.status == 0) {
					console.log("请求类型成功2！", res.data.data)
					this.tiaozhuanlist = this.tiaozhuanlist.concat(res.data.data);
				} else {
					console.log("请求类型失败2！")
				}
			});
		},
		methods: {

			reset() {
				this.data = [];
				this.text = "修改";
				this.form = {
					name: '',
					leixing: null,
					tiaozhuan: '',
				};
				this.pid = -1;
			},
			gettree() {
				var url = '/api/source/clrRipening/selectTree';
				this.$http.get(url).then(res => {
					if (res.data.status == 0) {
						console.log("请求目录成功！", res.data.data)
						this.data = res.data.data

					} else {
						this.$message.error('请求目录失败');
					}
				});
			},
			append(data) {
				if (data.dicType == 1) {
					this.$message.warning('表单无法添加下级！');
					return false;
				}
				this.text = "新增";
				this.dialogFormVisible = true;
				if (data == -1) {
					this.pid = data;
					console.log("点击了新增一级目录")
				} else {
					this.pid = data.dicId;
					console.log("点击了新增", data.id)
				}
				this.isadd = true

			},
			addtree() {
				console.log(this.form.leixing, typeof(this.form.leixing))
				if (this.form.name.trim() == '') {
					this.$message.warning('请输入名称！');
					return false;
				}
				if (this.form.leixing == null) {
					this.$message.warning('请选择类型！', this.form.leixing);
					return false;
				}
				if (this.form.leixing == 1 && this.form.tiaozhuan == '') {
					this.$message.warning('请选择文案！');
					return false;
				}
				this.dialogFormVisible = false;
				if (this.isadd) {
					var url = '/api/source/clrRipening/insertNote';
					var param = {
						"dicType": this.form.leixing,
						"dicDesc": this.form.name,
						"parentId": this.pid,
						"matId": this.form.tiaozhuan
					}
					this.$http.post(url, param).then(res => {
						if (res.data.status == 0) {
							this.reset();
							this.gettree();
							this.$message.success('新增成功');
						} else {
							this.$message.error('新增失败');
						}
					});
				} else {
					var url = '/api/source/clrRipening/updateNote';
					var param = {
						"dicId": this.dicId,
						"dicType": this.form.leixing,
						"dicDesc": this.form.name,
						"parentId": this.pid,
						"matId": this.form.tiaozhuan
					}
					this.$http.post(url, param).then(res => {
						if (res.data.status == 0) {
							this.reset();
							this.gettree();
							this.$message.success('修改成功');
						} else {
							this.$message.error('修改失败');
						}
					});
				}

			},
			edit(data) {
				console.log("点击了编辑", data)
				this.dialogFormVisible = true;
				this.text = "编辑";
				this.form = {
					name: data.dicDesc,
					leixing: data.dicType,
					tiaozhuan: data.matId,
				}
				this.dicId = data.dicId
				this.isadd = false
			},
			remove(data) {
				console.log("点击了删除", data.dicId)
				var url = '/api/source/clrRipening/updateNoteStatus';
				var param = {
					"dicId": data.dicId,
					"status": 1
				}
				this.$http.post(url, param).then(res => {
					if (res.data.status == 0) {
						this.reset();
						this.gettree();
						this.$message.success('删除成功');
					} else {
						this.$message.error('删除失败');
					}
				});
			},
			renderContent(h, {
				data
			}) {
				return ( 
				    <span class = "custom-tree-node" >
				 	    <span>{data.dicDesc}</span> 
					<span class = 'caozuo'>
					 <el-button size="mini" type="text" on-click={() => this.append(data)}>新增下级 </el-button> 
					 <el-button size="mini" type="text" on-click={() => this.edit(data)}>编辑 </el-button>
					 <el-button size="mini" type="text" on-click={() => this.remove(data)}> 删除 </el-button>
					  </span> 
				</span>
				);
			}
		}
	};
</script>
<style>
	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}

	.caozuo {
		margin-left: 50px;
	}

	.el-tree__empty-text {
		width: 100px;
		margin-left: 50px;
	}
</style>
